import Section from 'components/Section'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { AchieveTheme, Grid } from '@achieve/ascend'
import { BaseCarousel } from 'components/Carousels/BaseCarousel'

function Card({ item: { cardImage, cardTitleText, cardText }, priority }) {
  const textList = cardText?.json?.content ?? []
  const quote = textList?.[0]?.content ? { json: textList[0], links: cardText.links } : ''
  const attribution = textList?.[1]?.content ? { json: textList[1], links: cardText.links } : ''

  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column-reverse', lg: 'row' },
        justifyContent: { xs: 'flex-end', lg: 'space-between' },
        alignItems: { xs: 'center', lg: 'flex-start' },
      }}
    >
      <Grid size={{ xs: 12, lg: 4 }} className="lg:basis-1/3">
        <div
          className={
            'max-w-[415px] max-h-[295px] aspect-square min-w-[295px] lg:max-h-[415px] [&_img]:w-full [&_img]:h-full [&_img]:rounded-xl'
          }
        >
          <MediaImageStandard content={cardImage} fetchPriority="high" preload={priority} />
        </div>
      </Grid>
      <Grid size={{ xs: 12, lg: 7 }} className=" lg:basis-7/12 ">
        <Grid
          container
          direction="column"
          className={'text-center mb-8 px-10 lg:text-left lg:mb-0 lg:px-0'}
        >
          <Grid size={{ xs: 12 }}>
            <Typography
              className="displayMd lg:displayLg font-bold! mb-8 lg:mb-16"
              content={cardTitleText}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography
              className="displaySm lg:displayMd font-medium! mb-6 lg:mb-16"
              content={quote}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography content={attribution} className="bodyXs lg:headingMd font-light!" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

function FlatCarousel({
  carouselItems,
  idPrefix = 'page',
  dataTestId = 'page-testimonial-carousel-container',
}) {
  return (
    <Section
      backgroundColor={AchieveTheme?.ascend?.colors?.blue[500]}
      className={'text-white py-8 lg:pt-16 lg:pb-6'}
      contain={false}
    >
      <BaseCarousel
        items={carouselItems ?? []}
        renderItem={(item, index) => (
          <div data-testid={`${idPrefix}-flat-testimonial-carousel-item`}>
            <Card item={item} fetchPriority="high" preload={index === 0} />
          </div>
        )}
        classNameContainer="pt-0! lg:px-24!"
        classNameSlide="w-full"
        classNameIndicators="mt-8"
        dataTestId={dataTestId}
      />
    </Section>
  )
}

export { FlatCarousel }
